<template>
  <div
    class="comment"
    :class="[
      {
        'manager-comment':
          isActiveUser(comment.member_id) && type == TicketReplyType.COMMENT
      }
    ]"
  >
    <image-modal
      v-if="imageModalShow"
      :link="imageLink"
      @close="imageModalShow = false"
    />
    <div class="user-info">
      <div class="comment-profile-picture" v-if="comment.link">
        <img :src="baseURL + comment.link" alt="user" />
      </div>
      <div class="comment-profile-picture" v-else>
        <img
          :src="require('../../assets/mail.svg')"
          v-if="type == TicketReplyType.REPLY"
        />
        <img
          :src="require('../../assets/info.svg')"
          v-if="type == TicketReplyType.LOG"
        />
        <img
          :src="require('../../assets/mail.svg')"
          v-if="type == TicketReplyType.SENT_TO_CONTRACTOR"
        />
      </div>
    </div>
    <div class="comment-wrapper">
      <div class="balloon-wrapper">
        <div class="balloon">
          <div
            style="color:var(--primary-color)"
            class="username"
            @click="openMemberModal(comment)"
            v-if="
              !isActiveUser(comment.member_id) &&
                type == TicketReplyType.COMMENT
            "
          >
            <b>{{ comment.full_name }}</b>
          </div>
          <div
            style="color:var(--primary-color)"
            v-if="type != TicketReplyType.COMMENT"
          >
            <b v-if="type == TicketReplyType.REPLY">{{
              comment.contractor.name
            }}</b>
            <b
              v-if="
                type == TicketReplyType.LOG ||
                  type == TicketReplyType.SENT_TO_CONTRACTOR
              "
            >
              {{ comment.full_name }}
            </b>
          </div>
          <span class="comment-text" v-if="type == TicketReplyType.COMMENT">{{
            comment.comment_body
          }}</span>
          <span class="comment-text" v-if="type == TicketReplyType.REPLY">{{
            comment.body
          }}</span>
          <span class="comment-text" v-if="type == TicketReplyType.LOG"
            >je postavio/la {{ comment.status ? 'status' : 'prioritet' }} na
            {{ comment.status ? comment.status : comment.priority }}.
          </span>
          <span
            class="comment-text"
            v-if="type == TicketReplyType.SENT_TO_CONTRACTOR"
            >je poslao/la tiket serviseru</span
          >
          <br v-if="otherFiles.length > 0" />
          <a
            class="comment-attachement"
            v-for="media in otherFiles"
            :key="media.id"
            target="_blank"
            :href="baseURL + media.link"
          >
            {{ media.file_name }}
          </a>
        </div>
        <p class="time-elapsed">
          {{ calculateElapsedTime(comment.timestamp) }}
        </p>
      </div>
      <div class="comment-image-wrapper" v-if="imageFiles.length == 1">
        <img
          @click="openPictureModal(imageFiles[0].link)"
          :src="baseURL + imageFiles[0].link"
          alt="slika"
          class="uploaded-content"
        />
      </div>
      <div
        v-bind:class="
          isActiveUser(comment.member_id)
            ? 'comment-response-number-me'
            : 'comment-response-number-other'
        "
        v-if="
          comment.numOfResponses != '0' &&
            responses.length != 0 &&
            !isChatMessage
        "
        @click="openCommentResponses"
      >
        <i class="fas fa-reply"></i>
        {{ comment.numOfResponses }}
        <span v-if="comment.numOfResponses == '1'">odgovor</span>
        <span v-else>odgovora</span>
      </div>
      <div class="comment-responses">
        <div v-for="c in responses" :comment="c" :key="c.comment_id">
          <div
            class="comment"
            :class="{
              'manager-comment': isActiveUser(comment.member_id)
            }"
          >
            <image-modal
              v-if="imageModalShow"
              :link="imageLink"
              @close="imageModalShow = false"
            />
            <div class="user-info">
              <div class="comment-profile-picture" v-if="c.link">
                <img :src="baseURL + c.link" alt="user" />
              </div>
            </div>
            <div class="comment-wrapper">
              <div class="balloon-wrapper">
                <div class="balloon">
                  <span
                    style="color:var(--primary-color)"
                    class="username"
                    @click="openMemberModal(c)"
                    v-if="!isActiveUser(c.member_id)"
                  >
                    <b>{{ c.full_name }}</b>
                  </span>
                  <span class="comment-text">{{ c.comment_body }}</span>
                </div>
                <p class="time-elapsed">
                  {{ calculateElapsedTime(c.timestamp) }}
                </p>
              </div>
              <div class="comment-image-wrapper" v-if="c.com_media_link">
                <img
                  @click="openPictureModal(c.com_media_link)"
                  :src="baseURL + c.com_media_link"
                  alt="slika"
                  class="uploaded-content"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import ImageModal from '@/components/modal/ModalImage.vue';
import { mapMutations } from 'vuex';
import { TicketReplyType } from '@/util/UtilService.js';

export default {
  components: {
    ImageModal
  },
  props: {
    comment: {
      type: Object,
      required: true
    },
    postId: {
      type: String,
      required: false
    },
    isChatMessage: {
      type: Boolean,
      required: false
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_OBJECT_STORAGE_URL,
      imageLink: '',
      imageModalShow: false,
      responses: [],
      TicketReplyType: TicketReplyType
    };
  },
  computed: {
    imageFiles() {
      if (!this.comment.medias) {
        return [];
      }
      const imageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      return this.comment.medias.filter(el => imageTypes.indexOf(el.type) > -1);
    },
    otherFiles() {
      if (!this.comment.medias) {
        return [];
      }
      const imageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      return this.comment.medias.filter(
        el => imageTypes.indexOf(el.type) === -1
      );
    }
  },
  methods: {
    ...mapMutations('modal', ['setMember', 'showModal']),
    isActiveUser(commentMemberId) {
      return this.$store.getters.isManager(commentMemberId);
    },
    openMemberModal(comment) {
      this.setMember({
        id: comment.member_id,
        div_desc: comment.div_description,
        full_name: comment.full_name,
        profile_pic_URL: {
          link: comment.link
        }
      });
      this.showModal('ModalContentMemberDetails');
    },
    calculateElapsedTime(e) {
      let timeElapsed = new Date() - new Date(e);
      timeElapsed += 1000;
      let seconds = Math.floor(timeElapsed / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);
      // let months = Math.floor(days/30);
      if (seconds < 60) {
        return seconds + 's';
      } else if (minutes < 60) {
        return minutes + 'm';
      } else if (hours < 24) {
        return hours + 'h';
      } else {
        return days + 'd';
      }
    },
    openPictureModal(link) {
      this.imageLink = this.baseURL + link;
      this.imageModalShow = true;
    },
    restructureComments(data) {
      return data.map(el => {
        return {
          member_id: el.author_id,
          full_name: el.author_name,
          comment_body: el.body,
          comment_id: el.comment_id,
          link: el.profile_pic.link,
          timestamp: el.date,
          communityMembers: null,
          numOfResponses: el.num_of_comments
        };
      });
    },
    async openCommentResponses() {
      let response = await axios.post('post/get-comments', {
        community_id: this.$store.getters.getActiveCommunity.id,
        futureOrPast: '0',
        numOfPosts: '7',
        post_id: this.comment.comment_id,
        timestamp: ''
      });
      this.responses = this.restructureComments(response.data);
    }
  }
};
</script>

<style lang="scss">
.comment {
  display: flex;
  margin-bottom: 10px;

  .user-info {
    display: flex;
  }

  .comment-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 50%;
  }

  .balloon-wrapper {
    display: inline-flex;
    max-width: 100%;
    p {
      margin-top: auto;
    }
    .comment-attachement {
      color: var(--primary-color);
      cursor: pointer;
      display: block;
      width: fit-content;
    }
  }

  .balloon {
    margin-left: 10px;
    height: auto;
    padding: 5px 8px;
    width: 90%;
    max-width: 90%;
    background-color: #fabb4738;
    /* border: 1px solid #000000; */
    border-radius: 3px;

    p {
      -ms-word-wrap: break-word;
      word-wrap: break-word;
      margin-bottom: 0;
    }

    .comment-text {
      // white-space: pre-line;
      -ms-word-wrap: break-word;
      word-wrap: break-word;
      p {
        margin-bottom: 0;
      }
    }
  }
  .username {
    margin-right: 5px;
  }

  .username :hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .time-elapsed {
    margin-top: auto;
    margin-bottom: 0;
    padding: 5px 5px 0 5px;
    color: dimgrey;
    font-size: 14px;
  }

  .comment-image-wrapper :hover {
    cursor: pointer;
  }

  .uploaded-content {
    margin: 5px 10px 0 10px;
    width: 150px;
    height: auto;
    object-fit: scale-down;
    border-radius: 5px;
  }
}

.manager-comment {
  display: flex;
  flex-direction: row-reverse;

  .comment-attachement {
    float: right;
  }

  .balloon {
    background-color: #fabb4799;
    margin-right: 10px;
    margin-left: 0px;
  }

  .balloon-wrapper {
    flex-direction: row-reverse;
  }

  .comment-wrapper {
    align-items: flex-end;
  }
}

.comment-profile-picture {
  border-radius: 50%;
  overflow: hidden;
  height: 30px;
  width: 30px;

  img {
    max-width: 100%;
    max-height: 100%;
    width: 30px;
    height: 30px;
    object-fit: cover;
  }
}
.comment-response-number-me {
  color: var(--primary-color);
  cursor: pointer;
  margin-right: 10px;
  width: 100%;
  text-align: right;
}
.comment-response-number-other {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
  width: 100%;
  text-align: left;
}
.comment-responses {
  margin-top: 8px;
}
</style>
